var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55.64 40.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.83;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.53,0H7.11C3.19,0,0,2.3,0,5.14V35.07c0,2.83,3.19,5.14,7.11,5.14H48.53c3.92,0,7.11-2.31,7.11-5.14V5.14C55.64,2.3,52.45,0,48.53,0Zm3.84,35.07c0,1.53-1.72,2.77-3.84,2.77H7.11c-2.11,0-3.83-1.24-3.83-2.77V30.75l10.78-6.63a1.37,1.37,0,0,1,1.37,0l6.76,4.06a2.12,2.12,0,0,0,2.2-.08L40.45,16.47a1.28,1.28,0,0,1,.8-.22,1.26,1.26,0,0,1,.77.28l10.35,9.2v9.34Zm0-13.09L44.57,15a5.1,5.1,0,0,0-3.15-1.16,5.39,5.39,0,0,0-3.29.92l-15,10.85-5.61-3.36a5.64,5.64,0,0,0-5.58,0L3.28,27.64V5.14C3.28,3.61,5,2.37,7.11,2.37H48.53c2.12,0,3.84,1.24,3.84,2.77Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image_placeholder.2817dae0e998f9fee5b2e73fc48f50bd.svg";
export { ForwardRef as ReactComponent };